// Simple structured logger for frontend
const isDebugEnabled =
  process.env.REACT_APP_ENABLE_FRONTEND_DEBUG === "true" ||
  process.env.NODE_ENV === "development";

export const logInfo = (msg, data = {}) => {
  if (!isDebugEnabled) return;
  try {
    // eslint-disable-next-line no-console
    console.info(`[INFO] ${msg}`, data);
  } catch {}
};

export const logWarn = (msg, data = {}) => {
  if (!isDebugEnabled) return;
  try {
    // eslint-disable-next-line no-console
    console.warn(`[WARN] ${msg}`, data);
  } catch {}
};

export const logError = (msg, err = {}) => {
  try {
    // eslint-disable-next-line no-console
    console.error(`[ERROR] ${msg}`, isDebugEnabled ? err : "");
  } catch {}
};

export const logDebug = logInfo;

export default { logInfo, logWarn, logError, logDebug };

